<template>
  <base-layout>
    <template>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-9 pL0">
          <ul class="clearfix list-unstyled list-inline">
            <ul class="clearfix list-unstyled list-inline pull-left">
              <li>
                <h3
                  style="color: rgb(25, 34, 71); font-weight: 600;"
                >{{ $route.name == 'employee-tasks' ? "Tasks" : "Evaluation"}}</h3>
              </li>
              <span
                class="span-color"
              >{{$route.name == 'employee-tasks' ? taskCount : evaluationCount}}</span>
            </ul>
            <ul class="pull-right clearfix list-unstyled list-inline" style="margin-right: 76px;">
              <li>

                  <ob-button v-if="IsReportGenerationInProgress" :disabled="IsReportGenerationInProgress" type="secondary" @click="generateReport()">
                            <span v-if="IsReportGenerationInProgress" v-tooltip="'Timesheets report generation is in-progress so please wait till it is completed.'">Generate Evaluation Report</span>
                            <span v-else>Generate Evaluation Report</span>
                   </ob-button>
                <template v-else>
                <ob-button
                  type="secondary"
                  v-if="$route.name == 'evaluation'"
                  @click="generateReport()"
                  style="float:right;"
                  :disabled="evaluationCount == 0"
                >Generate Evaluation Report</ob-button>
                </template>
              </li>
            </ul>
          </ul>
        </div>
        <!-- <generate-report :EmployeeId="EmployeeId" :show.sync="showgeneratePopup"></generate-report> -->
        <generate-evalution-report :EmployeeId ="EmployeeId" :show.sync="showgeneratePopup"></generate-evalution-report>
      </div>
      <ob-layout :type="15">
        <template slot="left-section">
          <div class="tasks_tab">
            <li class="evaluation" :class="{'active-tab':  $route.name == 'evaluation' }">
              <span style="margin-left: 10px;">
                <router-link :to="{name:'evaluation'}">
                  <span>Evaluation</span>
                </router-link>
              </span>
            </li>
            <li class="task" :class="{'active-tab': $route.name == 'employee-tasks' }">
              <span style="margin-left: 10px;">
                <router-link :to="{name:'employee-tasks'}">
                  <span>Tasks</span>
                </router-link>
              </span>
            </li>
          </div>
        </template>
        <template slot="right-section">
          <router-view :taskCount.sync="taskCount" :evaluationCount.sync="evaluationCount"></router-view>
        </template>
      </ob-layout>
    </template>
  </base-layout>
</template>
<script>
import Task from "./Tasks/Task.vue";
import Evaluation from "./Tasks/Evaluation.vue";
// import GenerateReport from "./Timesheets/GenerateReport.vue";
import GenerateEvalutionReport from './Timesheets/GenerateEvalutionReport'

export default {
  data() {
    return {
      IsReportGenerationInProgress:false,
      taskCount: "",
      evaluationCount: "",
      tasks: null,
      showgeneratePopup: false,
      openAddTaskPopup: false,
      isTaskSelected: true,
      isEvaluationSelected: false
    };
  },
  components: {
    task: Task,
    evaluation: Evaluation,
    // "generate-report": GenerateReport
    "generate-evalution-report":GenerateEvalutionReport
  },
  mounted() {

    events.listen('IsTimesheetInProgress', (val) => {
      this.IsReportGenerationInProgress = val;
    })
  },
  computed: {
    EmployeeId() {
      return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : "";
    }
  },
  methods: {
    addTask() {
      this.openAddTaskPopup = true;
    },
    generateReport() {
      this.showgeneratePopup = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.tasks_empty {
  margin-top: 14%;
  text-align: center;
  vertical-align: middle;
}
.left_view {
  background-color: white;
  margin-top: 10px;
  margin-left: 20px;
  margin-right: 10px;
  width: 140px;
}
.right_view {
  background-color: white;
  height: 100%;
  margin-top: 10px;
}
.span-color {
  background: #fed4de;
  color: #dd3d64;
  border-radius: 10px;
  padding: 0px 12px;
  font-weight: 600;
}
.tasks_tab {
  .task {
    list-style-type: none;
    margin-top: 18px;
    margin-bottom: 10px;
    font-weight: 600;
    cursor: pointer;
    padding: 14px;
    a {
      color: #000000;
    }
  }
  .task.active-tab {
    background: #f0f7ff;
    border-left: 3px solid #59a2e7;
    a {
      color: #337ab7 !important;
    }
  }
}
.tasks_tab {
  .evaluation {
    list-style-type: none;
    margin-bottom: 12px;
    font-weight: 600;
    cursor: pointer;
    padding: 14px;
    a {
      color: #000000;
    }
  }
  .evaluation.active-tab {
    background: #f0f7ff;
    border-left: 3px solid #59a2e7;
    a {
      color: #337ab7 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Tasks.vue